import Fuse from 'fuse.js';
import { Option } from '../Options';

const fuseConfig = {
  includeScore: false,
  shouldSort: true,
  threshold: 0.3,
  keys: ['option', 'label'],
};

export const filterOptions = (arr: Option[], searchQuery: string): Option[] => {
  const fuse = new Fuse(arr, fuseConfig);
  if (searchQuery.length === 0) return arr;
  return fuse.search(searchQuery).map((option) => {
    return option.item;
  });
};
